export class FacePressuresForcesAtAngle {

    constructor(calculation, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.calculation = calculation ?? null;
        this.wedgeSlidingAngleZeta = data.wedgeSlidingAngleZeta ?? null;
        this.rectangularAreaRequiredSupportEarthForceEre = data.rectangularAreaRequiredSupportEarthForceEre ?? null;
        this.slidingWedgeWeightG = data.slidingWedgeWeightG ?? null;
        this.verticalLoadFromSolidPrismPv = data.verticalLoadFromSolidPrismPv ?? null;
        this.verticalSlipSurfaceShearForceFromCohesionTc = data.verticalSlipSurfaceShearForceFromCohesionTc ?? null;
        this.verticalSlipSurfaceShearForceFromFrictionTr = data.verticalSlipSurfaceShearForceFromFrictionTr ?? null;
        this.verticalSlipSurfaceShearForceFromFrictionCohesionT = data.verticalSlipSurfaceShearForceFromFrictionCohesionT ?? null;

    }

}
